import { render } from "./VillaBooking_old.vue?vue&type=template&id=96c7f4c2"
import script from "./VillaBooking_old.vue?vue&type=script&lang=js"
export * from "./VillaBooking_old.vue?vue&type=script&lang=js"

import "./VillaBooking_old.vue?vue&type=style&index=0&id=96c7f4c2&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__